module.exports = __webpack_public_path__ + "static/media/footer.b71ddc38.png";